import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import ArrowDownIcon from './ArrowDownIcon';
import { currentLanguage, supportedLanguageTags, supportedLocale } from './language';
import WorldIcon from './WorldIcon';

export default function LanguageMenu({
    wallet,
    t,
    i18n,
    islocal = true,
    color = '#ffffff',
    menuTextColor = '#1E1E1E',
    displayIconsInMobile = false,
    saveToLocal = true,
    supportedLangs = supportedLanguageTags(),
    defaultLang = undefined,
    onChange = () => {},
}) {
    const [anchorElLangMenu, setAnchorElLangMenu] = useState(null);
    const [language, setLanguage] = useState(null);

    const getInitialLanguage = () => {
        if (defaultLang !== undefined) {
            return supportedLangs.find((e) => e.value === defaultLang);
        } else {
            const currentLang = currentLanguage(wallet, i18n.language);
            return supportedLangs.find((e) => e.value === supportedLocale(currentLang));
        }
    };

    useEffect(() => {
        const initialLanguage = getInitialLanguage();
        setLanguage(initialLanguage);
    }, [defaultLang, wallet, i18n.language]);

    useEffect(() => {
        if (language && saveToLocal) {
            i18n.changeLanguage(language.value).then();
        }
    }, [language]);

    const handleLangMenu = (event) => {
        setAnchorElLangMenu(event.currentTarget);
    };

    const handleLangMenuClose = () => {
        setAnchorElLangMenu(null);
    };

    const onLanguageClick = (e) => {
        const selectedLanguage = e.currentTarget.dataset.lang;
        onChange(selectedLanguage);
        if (language.value !== selectedLanguage) {
            const lang = supportedLangs.find((e) => e.value === supportedLocale(selectedLanguage));
            setLanguage(lang);
            if (saveToLocal) localStorage.setItem(`currentLanguage#${wallet}`, selectedLanguage);
        }
        setAnchorElLangMenu(null);
    };

    if (!language) return <></>;

    return (
        <>
            <Stack
                direction={'row'}
                id={'lang-menu'}
                sx={{
                    cursor: 'pointer',
                    alignSelf: 'center',
                }}
            >
                <IconButton
                    aria-controls="menu-lang"
                    aria-haspopup="true"
                    onClick={handleLangMenu}
                    sx={{
                        p: { xs: '6px', sm: '1px' },
                        mr: { sx: 4, md: 0 },
                        color: 'inherit',
                    }}
                >
                    <Stack sx={{ display: { xs: displayIconsInMobile ? 'inline' : 'none', md: 'inline' }, mt: '6px' }}>
                        <WorldIcon fill={color} />
                    </Stack>

                    <Typography
                        ml={2}
                        alignSelf={'center'}
                        sx={{
                            marginRight: '10px',
                            color: color,
                            fontWeight: 600,
                            fontFamily: 'Poppins',
                            fontSize: { xs: '12px', sm: '14px' },
                        }}
                    >
                        {language.value.toLocaleUpperCase()}
                    </Typography>
                    <Stack sx={{ display: { xs: displayIconsInMobile ? 'inline' : 'none', md: 'inline' }, mt: '6px' }}>
                        <ArrowDownIcon fill={color} />
                    </Stack>
                </IconButton>
            </Stack>
            <Menu
                id="menu-lang"
                anchorEl={anchorElLangMenu}
                keepMounted
                open={Boolean(anchorElLangMenu)}
                onClose={handleLangMenuClose}
                slotProps={{
                    paper: {
                        sx: {
                            width: { xs: '105px', md: '125px' },
                            left: '1200px',
                            borderRadius: '8px',
                        },
                    },
                }}
            >
                {supportedLangs.map((languageTag) => (
                    <MenuItem onClick={onLanguageClick} key={t(languageTag.name)} data-lang={languageTag.value}>
                        <Typography variant="body2" fontWeight={500} color={menuTextColor}>
                            {islocal ? languageTag.localName : t(languageTag.name)}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
